(function() { window.GUID_a480438e_4475_4c94_9c98_4a1f8316dc93 = { getGuid: function() { return "a480438e-4475-4c94-9c98-4a1f8316dc93"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let FilterType;
        (function (FilterType) {
            FilterType[FilterType["Associations"] = 1] = "Associations";
            FilterType[FilterType["Operators"] = 2] = "Operators";
            FilterType[FilterType["Events"] = 3] = "Events";
            FilterType[FilterType["HomeBar"] = 4] = "HomeBar";
            FilterType[FilterType["Divisions"] = 5] = "Divisions";
            FilterType[FilterType["EntityType"] = 6] = "EntityType";
            FilterType[FilterType["PlayerType"] = 7] = "PlayerType";
            FilterType[FilterType["CSR"] = 8] = "CSR";
            FilterType[FilterType["Name"] = 9] = "Name";
            FilterType[FilterType["Date"] = 10] = "Date";
            FilterType[FilterType["OnlyMyResults"] = 11] = "OnlyMyResults";
            FilterType[FilterType["OnlyFinishedResults"] = 12] = "OnlyFinishedResults";
            FilterType[FilterType["OnlyUnfinishedResults"] = 13] = "OnlyUnfinishedResults";
            FilterType[FilterType["OnlyEntitiesResults"] = 14] = "OnlyEntitiesResults";
            FilterType[FilterType["Preset"] = 15] = "Preset";
            FilterType[FilterType["AdrState"] = 16] = "AdrState";
            FilterType[FilterType["Sport"] = 17] = "Sport";
            FilterType[FilterType["Feat"] = 18] = "Feat";
            FilterType[FilterType["WinsOrLosses"] = 19] = "WinsOrLosses";
            FilterType[FilterType["GameFormat"] = 20] = "GameFormat";
            FilterType[FilterType["DateRange"] = 21] = "DateRange";
            FilterType[FilterType["EventType"] = 22] = "EventType";
            FilterType[FilterType["OnlyResultsWithVideos"] = 23] = "OnlyResultsWithVideos";
            FilterType[FilterType["TimePeriod"] = 24] = "TimePeriod";
            FilterType[FilterType["Year"] = 25] = "Year";
            FilterType[FilterType["Distance"] = 26] = "Distance";
            FilterType[FilterType["City"] = 27] = "City";
            FilterType[FilterType["Address"] = 28] = "Address";
            FilterType[FilterType["OnlyFavoriteResults"] = 29] = "OnlyFavoriteResults";
            FilterType[FilterType["OnlyForCSRDetail"] = 30] = "OnlyForCSRDetail";
            FilterType[FilterType["Opponents"] = 31] = "Opponents";
            FilterType[FilterType["OnlyMyOpponents"] = 32] = "OnlyMyOpponents";
            FilterType[FilterType["Layout"] = 33] = "Layout";
            FilterType[FilterType["InUse"] = 34] = "InUse";
            FilterType[FilterType["Empty"] = 35] = "Empty";
            FilterType[FilterType["OutOfOrder"] = 36] = "OutOfOrder";
            FilterType[FilterType["Unread"] = 37] = "Unread";
            FilterType[FilterType["Read"] = 38] = "Read";
            FilterType[FilterType["NotificationTemplateId"] = 39] = "NotificationTemplateId";
            FilterType[FilterType["ForMe"] = 40] = "ForMe";
            FilterType[FilterType["Following"] = 41] = "Following";
        })(FilterType = Enumeration.FilterType || (Enumeration.FilterType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=FilterType.pre.js.map
